const renderShader = /* wgsl */ `
@group(0) @binding(0)
var trail: texture_2d<f32>;

struct RenderSettings {
    color0: vec4f,
    color1: vec4f,
    color2: vec4f,
    color3: vec4f,
};

@group(0) @binding(1)
var<uniform> settings: RenderSettings;

@group(0) @binding(2)
var boundaries: texture_2d<f32>;

struct VertexOutput {
    @builtin(position) position: vec4f,
    @location(0) uv: vec2f,
};

@vertex
fn vertexMain(
    @builtin(vertex_index) vertexIndex: u32
) -> VertexOutput {
    var positions = array<vec2f, 3>(
        vec2f(-1.0, -1.0),
        vec2f(3.0, -1.0),
        vec2f(-1.0, 3.0)
    );

    var output: VertexOutput;

    let position = positions[vertexIndex];

    output.position = vec4f(
        position,
        0.0,
        1.0
    );

    output.uv =
        position *
        0.5 +
        vec2f(0.5);

    return output;
}

@fragment
fn fragmentMain(
    input: VertexOutput
) -> @location(0) vec4f {
    let dimensions = textureDimensions(trail);

    let uv = clamp(
        input.uv,
        vec2f(0.0),
        vec2f(0.999999)
    );

    let pixel = vec2i(
        uv *
        vec2f(dimensions)
    );

    let concentration = textureLoad(
        trail,
        pixel,
        0
    );

    var color =
        settings.color0.rgb *
        concentration.r;

    color +=
        settings.color1.rgb *
        concentration.g;

    color +=
        settings.color2.rgb *
        concentration.b;

    color +=
        settings.color3.rgb *
        concentration.a;

    color = clamp(
        color,
        vec3f(0.0),
        vec3f(1.0)
    );

    // Render environmental walls over the trail field.
    let boundary = textureLoad(
        boundaries,
        pixel,
        0
    ).r;

    if (boundary > 0.5) {
        color = vec3f(
            0.62,
            0.65,
            0.63
        );
    }

    return vec4f(
        color,
        1.0
    );
}
`;

export default renderShader;
